import { useRef } from "react"

import Style from "./style"

import useDeleteAccount from "entity/account/useDeleteAccount"

import DefaultModal from "shared/ui/DefaultModal"
import DefaultButton from "shared/ui/DefaultButton"
import DefaultInput from "shared/ui/DefaultInput"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const WithdrawConfirmModal = ({ closeEvent }) => {
    const confirmRef = useRef()

    const [deleteAccount] = useDeleteAccount()
    const [, setAlert] = useAlertModalAtom()

    const putNicknameEvent = () => {
        if (confirmRef.current.value === "삭제") {
            deleteAccount()
        } else {
            setAlert("정확하게 입력해 주세요.")
        }
    }

    return (
        <DefaultModal title="마지막 단계" closeEvent={closeEvent}>
            <Style.Content>
                <DefaultInput placeholder="'삭제' 라고 입력해 주세요." inputRef={confirmRef} />
            </Style.Content>
            <DefaultButton clickEvent={putNicknameEvent}>탈퇴하기</DefaultButton>
        </DefaultModal>
    )
}

export default WithdrawConfirmModal